export enum ProfileMergeAction {
  Ignore = 'Ignore',
  Merge = 'Merge',
  Add = 'Add',
}
